<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                Suspension Report
            </div>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="suspensionReportForm">
            <div class="row">
                <div class="col-12 ml-3">
                    <!-- <button class="btn btn-secondary" (click)="Reset()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="Reset()"></app-button>

                </div>
                <div class="col-xl-1"></div>
                <div class="col-xl-10">
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Start Date</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="startDate"
                                    formControlName="startDate" selectable="isSelectable(date,type)" id="startDate"
                                    [max]="toMaxDate" autocomplete="off" placeholder="Select From Date" class="custom-input-border"
                                    specialIsAlphaNumeric (click)="openStartDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>End Date</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="endDate"
                                    formControlName="endDate" selectable="isSelectable(date,type)" id="endDate"
                                    autocomplete="off" [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                    class="custom-input-border" specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-12 mt-5 d-flex justify-content-center">
                            <button class="btn btn-primary mr-3"
                                (click)="generateExcel()">
                                Generate Report
                            </button>

                        </div>
                        <div class="col-12 mt-4">
                            <mat-label style=" font-style:italic; font-weight: bold;">
                                Note: To generate a report for all the existing records leave the start and end date fields blank.
                            </mat-label>
                        </div>
                    </div>
                </div>
                <div class="col-xl-1"></div>

            </div>
        </form>

    </div>
</div>
